export default {
  "responsive-content": () => import("/app/layouts/responsiveContent.vue").then(m => m.default || m),
  "responsive-interactive": () => import("/app/layouts/responsiveInteractive.vue").then(m => m.default || m)
}